import { api } from '@/core/api/';
const apiUrl = 'api/documents';

export default {
  downloadFile(documentFile) {
    const byteChars = atob(documentFile.content);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    let blob = new Blob([byteArray], {
      type: documentFile.contentType,
    });
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = documentFile.filename;
    link.click();
    link.remove();
  },
  async downloadFromServer(documentId) {
    await api
      .get(`${apiUrl}/downloaddocument?id=${documentId}`)
      .then((response) => {
        this.downloadFile(response.data);
      });
  },

  async downloadFromServerByName(fileName, documentType) {
    await api
      .get(
        `${apiUrl}/downloaddocumentbyname?fileName=${fileName}&documentType=${documentType}`
      )
      .then((response) => {
        this.downloadFile(response.data);
      });
  },
  async downloadatdocument(documentId, peiAtServiceId, documentTypeId) {
    await api
      .get(
        `${apiUrl}/downloadatdocument?id=${documentId}&peiAtServiceId=${peiAtServiceId}&documentTypeId=${documentTypeId}`
      )
      .then((response) => {
        this.downloadFile(response.data);
      });
  },
};
